/*! s07 — smooth anchor scroll for in-page #links (with offset so the user
 *  sees a bit of headroom above the target). Defensive: respects e.preventDefault
 *  already called by other handlers. */
(function(){
  if (window.__s07AnchorScroll) return;
  window.__s07AnchorScroll = true;
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.length < 2) return;
    var t;
    try { t = document.querySelector(href); } catch(_) { return; }
    if (!t) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var y = t.getBoundingClientRect().top + window.scrollY - 16;
    window.scrollTo({ top: y, behavior: 'smooth' });
    // Update URL hash without jumping
    if (history.replaceState) history.replaceState(null, '', href);
  });
})();
